module.exports = "/images/icon-heart-white.svg?a5f2ebe1779800bd43b7921a9bf7de41";